export var ELEMENTS_CHANNEL = 'fabric-elements';
//# sourceMappingURL=_constants.js.map